import {
  EyeOffIcon,
  ThumbsDownIcon,
  ThumbsUpIcon,
  Undo2Icon,
} from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@ui/button";

import { SearchDecision, SearchLastDecision } from "@/types";

const decisionConfig: Record<
  SearchDecision,
  { Icon: typeof ThumbsUpIcon; iconClassName: string; label: string }
> = {
  [SearchDecision.HIDDEN]: {
    Icon: EyeOffIcon,
    iconClassName: "text-slate-400",
    label: "Hidden",
  },
  [SearchDecision.INTERESTED]: {
    Icon: ThumbsUpIcon,
    iconClassName: "text-blue-700",
    label: "Interested",
  },
  [SearchDecision.UNINTERESTED]: {
    Icon: ThumbsDownIcon,
    iconClassName: "text-slate-400",
    label: "Un-interested",
  },
};

// Rear-view mirror for fast 1 / 2 runs: the last decision made and a way back.
export const SearchLastDecisionRow = ({
  lastDecision,
}: {
  lastDecision: SearchLastDecision | null;
}) => {
  /* Render */
  const render = () => {
    if (!lastDecision) return null;
    const { Icon, iconClassName, label } =
      decisionConfig[lastDecision.decision];
    return (
      <Row
        className="items-center gap-2 rounded-xl border border-slate-100 bg-slate-50 py-1.5 pl-3 pr-1.5 shadow-sm"
        key={lastDecision.talentId}
      >
        <Icon className={`h-3.5 w-3.5 shrink-0 ${iconClassName}`} />
        <Text className="min-w-0 flex-1 truncate text-xs font-normal text-slate-600">
          <span className="font-medium text-slate-700">
            {lastDecision.candidateName}
          </span>{" "}
          · {label}
        </Text>
        <Button
          className="h-6 w-6 shrink-0 text-slate-400 hover:text-slate-700"
          onClick={lastDecision.undo}
          size="icon"
          title="Undo (U)"
          type="button"
          variant="ghost"
        >
          <Undo2Icon className="h-3.5 w-3.5" />
        </Button>
      </Row>
    );
  };

  return render();
};
